import React from 'react';
import { DownloadIcon, SearchIcon, ShieldIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: DownloadIcon,
    text: 'Descargas el manual en tu teléfono o tablet para tenerlo siempre a mano.'
  }, {
    icon: SearchIcon,
    text: 'Identificas tus micro-señales personales usando las hojas de trabajo incluidas.'
  }, {
    icon: ShieldIcon,
    text: 'Aplicas el "Ancla Rápida" en cuanto sientas el primer síntoma y recuperas la calma en minutos.'
  }];
  return <section className="w-full py-24 px-4 bg-brand-cream" data-id="element-119">
      <div className="max-w-5xl mx-auto" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <span className="text-brand-purple font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-122">
            Cómo funciona
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-slate" data-id="element-123">
            Tres pasos hacia tu calma
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-124">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-lavenderDark/50 z-0" data-id="element-125"></div>

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-126">
                <div className="w-24 h-24 rounded-full bg-white shadow-md border border-brand-lavender flex items-center justify-center mb-6 relative" data-id="element-127">
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-brand-coral text-white font-bold flex items-center justify-center text-sm" data-id="element-128">
                    {index + 1}
                  </div>
                  <Icon className="w-10 h-10 text-brand-purple" aria-hidden="true" data-id="element-129" />
                </div>
                <p className="text-lg text-brand-navy leading-relaxed px-4" data-id="element-130">
                  {step.text}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}